<template>
  <div>
    <v-card>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="customerList"
        item-key="phone"
        class="elevation-1"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        show-select
      >
        <template v-slot:top>
          <v-toolbar
            flat
            class="section-toolbar"
          >
            <v-toolbar-title>Customer List</v-toolbar-title>
            <v-spacer></v-spacer>
            <div class="toolbar-actions">
              <v-dialog
                v-model="dialog"
                max-width="500px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    small
                    class="toolbar-btn"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Add Customer
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-form ref="customerForm">
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.firstName"
                            label="First Name"
                            placeholder="Enter first name"
                            :rules="requiredRules"
                            required
                          ></v-text-field>
                        </v-col>

                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.lastName"
                            label="Last Name"
                            placeholder="Enter last name"
                            :rules="requiredRules"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.address"
                            label="Address"
                            placeholder="Enter address"
                            :rules="requiredRules"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.city"
                            label="City"
                            placeholder="Enter city"
                            :rules="requiredRules"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.state"
                            label="State"
                            placeholder="Enter state"
                            :rules="requiredRules"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.zip"
                            label="Zip Code"
                            placeholder="Enter zip"
                            :rules="requiredRules"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.phone"
                            label="Phone"
                            placeholder="Enter phone"
                            :rules="phoneRules"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.email"
                            label="Email"
                            placeholder="Enter email"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.numberOfServices"
                            label="Number of Services Per Year"
                            placeholder="Enter number of services per year"
                            type="number"
                            :rules="numberOfServicesRules"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.percentDiscount"
                            label="Discount for this customer (percent)"
                            placeholder="Enter discount percent"
                            type="number"
                            :rules="percentDiscountRules"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.regularPrice"
                            label="Regular Price Per Service"
                            placeholder="Enter regular price"
                            type="number"
                            :rules="regularPriceRules"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-select
                            v-model="selectedDate"
                            :items="deadlines"
                            item-text="title"
                            item-value="value"
                            label="Offer Deadline"
                            placeholder="Select offer deadline"
                            :rules="requiredRules"
                            required
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-btn
                color="error"
                outlined
                small
                class="toolbar-btn"
                :disabled="selected.length === 0"
                @click="deleteSelected"
              >
                Delete Selected
              </v-btn>

              <v-btn
                color="error"
                outlined
                small
                class="toolbar-btn"
                @click="deleteAllCustomers"
              >
                Delete All
              </v-btn>
            </div>
          </v-toolbar>

          <v-dialog v-model="dialogDeleteSelected" max-width="500px">
              <v-card>
                <v-card-title class="headline">Are you sure you want to delete <br /> Selected Customers?</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDeleteSelected">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="deleteSelectedConfirm">OK</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="headline">Are you sure you want to delete the <br /> selected Customers?</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDeleteAll" max-width="500px">
              <v-card>
                <v-card-title class="headline">Are you sure you want to delete all <br /> Customers?</v-card-title>
                <v-card-text>
                    <v-text-field
                      v-model='deleteAllConfirmText'
                      label='Type "delete" to confirm'
                      title='Type "delete" to confirm'
                      :rules='deleteAllConfirmTextRules'
                      required
                    ></v-text-field>
                  </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDeleteAll">Cancel</v-btn>
                  <v-btn :disabled="!(deleteAllConfirmText === 'delete')" color="blue darken-1" text @click="deleteAllConfirm">OK</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn
            color="primary"
            @click="getCustomers"
          >
            Reset
          </v-btn>
        </template>
        <template 
          v-slot:item.date="{ item }"
        >
          <!-- <span>{{ new Date(item.date).toLocaleString() }}</span> -->
          <span> {{new Date(item.date).toDateString()}} </span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import _ from "lodash"

import { DB } from '../firebase/db'
import { mapState } from 'vuex'

export default {
  name: 'CustomerList',
  data() {
    return {
      sortBy: 'date',
      sortDesc: true,
      customerList: [],
      selectedDate: undefined,
      selected: [],
      headers: [
        { text: 'Actions', value: 'actions', sortable: false },
        {
          text: 'First Name',
          align: 'start',
          sortable: false,
          value: 'firstName',
        },
        { text: 'Last Name', value: 'lastName' },
        { text: 'Address', value: 'address' },
        { text: 'City', value: 'city' },
        { text: 'State', value: 'state' },
        { text: 'Zip', value: 'zip' },
        { text: 'Phone', value: 'phone' },
        { text: 'Email', value: 'email' },
        { text: 'Number of Services Per Year', value: 'numberOfServices' },
        { text: 'Percent Discount', value: 'percentDiscount' },
        { text: 'Regular Price', value: 'regularPrice' },
        { text: 'Level Pay Monthly Cost', value: 'levelPayMonthlyCost' },
        { text: 'Offer Deadline', value: 'deadline', dataType: "Date" },
        { text: 'Agreement Sent Date', value: 'agreementSentDate' },
        { text: "Date Added", value: "date", dataType: "Date" },
      ],
      dialog: false,
      dialogDelete: false,
      dialogDeleteAll: false,
      dialogDeleteSelected: false,
      deleteAllConfirmText: '',
      deleteAllConfirmTextRules: [
        v => /delete\b/.test(v) || '"delete" is required',
      ],
      editedIndex: -1,
      requiredRules: [
        v => (v !== null && v !== undefined && String(v).trim() !== '') || 'Required',
      ],
      phoneRules: [
        v => (v !== null && v !== undefined && String(v).trim() !== '') || 'Phone is required',
        v => /[0-9]{10}/.test(String(v).replace(/\D/g, '')) || 'Phone must be a 10 digit number, no spaces, no non-digits',
      ],
      numberOfServicesRules: [
        v => (v !== null && v !== undefined && v !== '') || 'Required',
        v => Number(v) > 0 || 'Must be greater than 0',
      ],
      percentDiscountRules: [
        v => (v !== null && v !== undefined && v !== '') || 'Required',
        v => Number(v) >= 0 || 'Must be 0 or greater',
      ],
      regularPriceRules: [
        v => (v !== null && v !== undefined && v !== '') || 'Required',
        v => Number(v) > 0 || 'Must be greater than 0',
      ],
      editedItem: {
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        email: '',
        numberOfServices: '',
        percentDiscount: '',
        regularPrice: '',
        agreementSentDate: 'Not Sent'
      },
      defaultItem: {
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        email: '',
        numberOfServices: '',
        percentDiscount: '',
        regularPrice: '',
        agreementSentDate: 'Not Sent'
      },
    }
  },
  computed: {
    ...mapState(['user']),
    formTitle () {
      return this.editedIndex === -1 ? 'Customer Info' : 'Edit Item'
    },
    showDeleteSelected() {
      return this.selected[0]
    },
    deadlines() {
      var twoWeeks = new Date();
      var fourWeeks = new Date();
      var sixWeeks = new Date();
      twoWeeks = new Date(twoWeeks.setDate(twoWeeks.getDate() + 14))
      fourWeeks = new Date(fourWeeks.setDate(fourWeeks.getDate() + 28))
      sixWeeks = new Date(sixWeeks.setDate(sixWeeks.getDate() + 42))

      let items = [{
          title: '2 Weeks from Today',
          value: twoWeeks.toDateString()
        },
        {
          title: '4 Weeks from Today',
          value: fourWeeks.toDateString()
        },
        {
          title: '6 Weeks from Today',
          value: sixWeeks.toDateString()
        }]
      // When editing, include existing deadline if it's not in the standard options (e.g. from a past selection)
      if (this.editedIndex >= 0 && this.editedItem.deadline) {
        const values = items.map(i => i.value)
        if (!values.includes(this.editedItem.deadline)) {
          items = [{ title: 'Previously set: ' + this.editedItem.deadline, value: this.editedItem.deadline }, ...items]
        }
      }
      return items
    },
    levelPayMonthlyCost() {
      return (Math.round(((this.editedItem.regularPrice * this.editedItem.numberOfServices)/12 - ((this.editedItem.percentDiscount * .01) * this.editedItem.regularPrice * this.editedItem.numberOfServices / 12)) * 100)/100).toFixed(2)
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },
  methods: {
    getCustomers(){
      let docRef = DB.collection('user').doc(this.user.uid)
        docRef.get()
          .then((user) => {
            user = user.data()
            if (!user.customerList) {
              this.customerList = []
            } else {
              this.customerList = user.customerList
            }
          })
    },

    deleteAllCustomers() {
      this.dialogDeleteAll = true
    },

    deleteAllConfirm() {
      if (this.deleteAllConfirmText === 'delete') {
        this.customerList = []
        this.updateFirebase()
        this.closeDelete()
      }
    },

    editItem (item) {
      this.editedIndex = this.customerList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      if (this.editedItem.phone && String(this.editedItem.phone).startsWith('+1')) {
        this.editedItem.phone = String(this.editedItem.phone).slice(2)
      }
      this.selectedDate = item.deadline || undefined
      this.dialog = true
    },

    deleteSelected () {
      let len = this.customerList.length
      _.pullAll(this.customerList, this.selected)

      if (!(len === this.customerList.length)) {
        this.dialogDeleteSelected = true
      }
      
    },

    deleteSelectedConfirm () {
      this.updateFirebase()
      this.closeDelete()
    },

    closeDeleteSelected () {
      this.dialogDeleteSelected = false
    },

    deleteItem (item) {
      this.editedIndex = this.customerList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.customerList.splice(this.editedIndex, 1)
      this.updateFirebase()
      this.closeDelete()
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.selectedDate = undefined
        if (this.$refs.customerForm) {
          this.$refs.customerForm.resetValidation()
        }
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDeleteAll () {
      this.dialogDeleteAll = false
      this.deleteAllConfirmText = ''
    },

    save () {
      if (!this.$refs.customerForm.validate()) {
        return
      }

      this.editedItem.numberOfServices = Number(this.editedItem.numberOfServices)
      this.editedItem.percentDiscount = Number(this.editedItem.percentDiscount)
      this.editedItem.regularPrice = Number(this.editedItem.regularPrice)

      if (this.editedIndex > -1) {
        this.editedItem.phone = this.validatePhone(this.editedItem.phone)
        this.editedItem.levelPayMonthlyCost = this.levelPayMonthlyCost
        this.editedItem.deadline = this.selectedDate
        Object.assign(this.customerList[this.editedIndex], this.editedItem)
      } else {
        this.editedItem.phone = this.validatePhone(this.editedItem.phone)
        this.editedItem.levelPayMonthlyCost = this.levelPayMonthlyCost
        this.editedItem.deadline = this.selectedDate
        this.editedItem.date = new Date().getTime()
        this.customerList.push(this.editedItem)
      }
      this.updateShowCompletedButton()
      this.updateFirebase()
      this.close()
    },

    validatePhone(number) {
      const digits = String(number).replace(/\D/g, '')
      if (digits.length === 10) {
        return '+1' + digits
      } else if (digits.length === 11 && digits.charAt(0) === '1') {
        return '+' + digits
      } else if (String(number).length === 12 && String(number).charAt(0) === '+') {
        return number
      } else {
        return 'Invalid Phone'
      }
    },

    updateShowCompletedButton() {
      this.$emit('updateShowCompletedButton')
    },

    updateFirebase() {
      let customerAccountRef = DB.collection("user").doc(this.user.uid)

      customerAccountRef
        .set({
          customerList: this.customerList
        }, { merge: true })
        .then(() => {
          this.reloadCustomerComponent()
          this.getCustomers()
        })
        .catch((err) => {
          console.error('Error setting Document: ', err)
          // this.resetData()
        })
    },

    reloadCustomerComponent() {
      this.$store.dispatch('iterateKey')
    },
  },
  components: {},
  mounted() {
    this.getCustomers()
  },
}
</script>

<style scoped>
.section-toolbar {
  flex-wrap: wrap;
}

.toolbar-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 0;
}

.toolbar-btn {
  margin: 0;
}
</style>